module.exports = __webpack_public_path__ + "img/q2.704a7bbd.webp";